module.exports = __webpack_public_path__ + "i18n/en_5e8a23941078f41ea057cf49dd8cdedc.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 153